module.exports = __webpack_public_path__ + "img/author1.245afd41.png";